// ConfirmDialog.js
import React from "react";
import './ConfirmDialog.scss'

const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="confirm-dialog">
      <div className="confirm-dialog-content">
        <p>{message}</p>
        <div className="confirm-dialog-buttons">
          <button onClick={onConfirm} className="yes">Yes</button>
          <button onClick={onCancel} className="no">No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
